export default "__VITE_ASSET__C_pODk_O__"